import React, { useState } from 'react';
import { DayPicker } from 'react-day-picker';
import styled from 'styled-components';
import 'react-day-picker/dist/style.css';

interface CustomToggleProps {
  toggleItem: any;
  toggleFirstTitle?: string;
  toggleSecondTitle?: string;
  onChange: any;
  disabled?: boolean;
}

const CustomToggle: React.FC<CustomToggleProps> = ({
  toggleItem,
  toggleFirstTitle,
  toggleSecondTitle,
  onChange,
  disabled,
}) => {
  return (
    <Style>
      <div className="viewType" onClick={() => onChange(!toggleItem)}>
        <button
          className={`toggleButton ${!toggleItem && 'active'} ${!toggleFirstTitle && 'noTitle'}`}
          disabled={disabled}>
          {toggleFirstTitle}
        </button>
        <button
          className={`toggleButton ${toggleItem && 'active'} ${!toggleSecondTitle && 'noTitle'}`}  disabled={disabled}>
          {toggleSecondTitle}
        </button>
      </div>
    </Style>
  );
};

export default CustomToggle;

const Style = styled.div`
  .viewType {
    display: flex;
    align-items: center;
    width: min-content;
    margin: 6px 0 2px 0;
    border-radius: 4px;
    background: #ddd;
    padding: 0;
    white-space: nowrap;

    .toggleButton {
      padding: 2px 0;
      color: #aaa;
      font-size: 12px;
      line-height: 16px;
      font-weight: 500;
      border: none;
      padding: 2px 10px;
      background: none;
    }
    .toggleButton.noTitle {
      padding: 10px 0;
    }
    .toggleButton.active {
      background: #000;
      color: #fff;
      border-radius: 4px;
    }
  }
`;
